import { createContext, useContext } from 'react';
import { IUser } from '../../model/store.model';

type PersonalDataContextType = {
    personalData: IUser;
    setPersonalData: (value: IUser) => void;
};

export const PersonalDataContext = createContext({} as PersonalDataContextType);

export const usePersonalDataContext = () => {
    const context = useContext(PersonalDataContext);

    if (!context) throw new Error('usePersonalDataContext must be used within a PersonalDataProvider');

    return context;
};
